
import { getFirestore, doc, getDoc, updateDoc, writeBatch, collection, serverTimestamp, getDocs, query, orderBy, deleteDoc } from "firebase/firestore";
import { app } from "../firebase-config.js";

const db = getFirestore(app);

/**
 * [CRITICAL] Admin Rescue Service
 * - Restores Ownership
 * - Migrates Array Chapters to Subcollection Episodes
 */
export const AdminRescueService = {

    /**
     * 1. Diagnose a Series
     */
    diagnoseSeries: async (seriesId) => {
        try {
            const ref = doc(db, "series", seriesId);
            const snap = await getDoc(ref);

            if (!snap.exists()) return "Series Not Found";

            const data = snap.data();
            const subColRef = collection(db, "series", seriesId, "episodes");
            const subSnap = await getDocs(subColRef);

            return {
                id: snap.id,
                title: data.title,
                authorId: data.authorId,
                chaptersArrayLength: data.chapters ? data.chapters.length : 0,
                subCollectionSize: subSnap.size,
                chaptersArray: data.chapters || [],
                status: "Ready for Repair"
            };
        } catch (e) {
            console.error(e);
            return "Error: " + e.message;
        }
    },

    /**
     * 2. Execute Repair
     * @param {string} seriesId 
     * @param {string} correctAuthorId 
     */
    repairSeries: async (seriesId, correctAuthorId) => {
        console.log(`[Rescue] Starting Repair for ${seriesId}...`);

        try {
            const batch = writeBatch(db);
            const seriesRef = doc(db, "series", seriesId);
            const seriesSnap = await getDoc(seriesRef);

            if (!seriesSnap.exists()) throw new Error("Series missing");
            const data = seriesSnap.data();

            // A. Restore Ownership
            if (correctAuthorId && data.authorId !== correctAuthorId) {
                console.log(`[Rescue] Restoring Author: ${data.authorId} -> ${correctAuthorId}`);
                batch.update(seriesRef, {
                    authorId: correctAuthorId,
                    lastUpdatedByAdmin: serverTimestamp()
                });
            }

            /* 
            // B. Migrate Episodes (DISABLED BY USER REQUEST)
            // Strategy Changed: Keep data in location, only fix ownership.
            */
            console.log(`[Rescue] Migration skipped. Only checking ownership.`);

            await batch.commit();
            console.log("[Rescue] Repair Complete!");
            return true;

        } catch (e) {
            console.error("[Rescue] Failed:", e);
            throw e;
        }
    }
};
